export const language: any ={
  LabelCarts:"장바구니",
  Material:"재료",
  nodata: "장바구니에 데이터가 없습니다",
}

